import React from 'react';
import Calculator from './Calculator';
import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

const theme = createMuiTheme({
  palette: {
    type: 'light',
    primary: {
      // light: will be calculated from palette.primary.main,
      main: '#ffc107',
      // dark: will be calculated from palette.primary.main,
      // contrastText: will be calculated to contrast with palette.primary.main
    },
    secondary: {
      light: '#ffffff',
      main: '#ffffff',
      // dark: will be calculated from palette.secondary.main,
      contrastText: '#ffffff',
    },
    // Used by `getContrastText()` to maximize the contrast between
    // the background and the text.
    contrastThreshold: 3,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset: 0.2,
  },
  // typography: {
  //   fontSize: 18,
  // },
});

function App() {
  return (
    <header id='reactcalc' className="container pt-5 pb-5 mt-4">
      {/* <Typography variant="h1" className="pb-4" component="h2" style={{color: '#fff', fontWeight: 'bold', textAlign: 'center'}}>Рассчитать стоимость услуг</Typography> */}
      <ThemeProvider theme={theme}>
        <Calculator />
      </ThemeProvider>
    </header>
  );
}

export default App;
